const getScrollbarWidth = (): number => window.innerWidth - document.documentElement.clientWidth;

export default getScrollbarWidth;
